import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-document\"><path d=\"M10 1H5.003a2 2 0 0 0-2 2H3v10a2 2 0 0 0 2 2h5.997a2 2 0 0 0 2-2H13V4zm0 1.414 1.587 1.587H10zM11.997 12v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4h.003V3c0-.551.448-1 1-1H9v3h3v7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol